/****************************************************************
 * WARNING THIS FILE IS AUTOGENERATED AND SHOULD NOT BE MODIFIED *
 ****************************************************************/
import * as React from "react"
import Svg from "@oui/system/Svg"
type DefaultProps = typeof defaultProps
type SvgProps = React.ComponentPropsWithoutRef<typeof Svg>
type Props = DefaultProps &
  Omit<SvgProps, "fill" | "height" | "stroke" | "viewBox" | "width">
const defaultProps = {
  label: "Filter",
  size: 20
}

const SvgFilter = ({ size, ...props }: Props) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="currentcolor"
    stroke="currentcolor"
    {...props}
  >
    <path d="M3 3v2.075l5.688 5.511V17l2.624-2.625v-3.789L17 5.076V3H3zm.875.875h12.25v.875l-5.688 5.447v3.761l-.874.94v-4.7L3.875 4.75v-.875z" />
  </Svg>
)

SvgFilter.defaultProps = defaultProps
export default SvgFilter
